import { useCallback, useState } from "react";
import moment, { Moment } from "moment";

import { OperationPeaksResponse } from "./types";
import api from "../../services/api";
import { notifyError } from "../../utils/notifications";

const useOperationPeaks = () => {
  const [selectedDate, setSelectedDate] = useState<Moment>(moment());
  const [data, setData] = useState<OperationPeaksResponse | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchOperationPeaks = useCallback(async (date: Moment) => {
    setLoading(true);

    try {
      const response = await api.get("operation_peaks", {
        date: date.format("YYYY-MM-DD"),
      });

      setData(response);
    } catch (error) {
      notifyError("Erro ao buscar dados do dashboard de picos de operação");
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleApplyFilters = useCallback(() => {
    fetchOperationPeaks(selectedDate);
  }, [fetchOperationPeaks, selectedDate]);

  return {
    selectedDate,
    setSelectedDate,
    data,
    loading,
    handleApplyFilters,
  };
};

export default useOperationPeaks;
